import React from 'react';
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-react';

const ContentSlotCard = ({ fields, rendering }) => {
  return (
    <div className="vds-grid__column vds-grid__column--lg-8">
      <div className="vds-content-slot-card">
        <div className="vds-content-slot-card__inner">
          <div className="vds-content-slot-card__item">
            <Text
              tag="h3"
              className="vds-type-subtitle-2 vds-margin-bottom-spacing-0"
              field={fields.heading}
              data-testid={`${fields.testid?.value}-heading`}
            />
            <Text
              tag="p"
              className="vds-type-body-small"
              field={fields.supportingText}
              data-testid={`${fields.testid?.value}-supportingtext`}
            />
          </div>
          <div className="vds-content-slot-card__item">
            <div className="vds-grid">
              <Placeholder name="contentSlotCard-inner" rendering={rendering} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentSlotCard;
